import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const getQuotaTypes = createAction(`${moduleSlug}/GET_QUOTA_TYPES`);
export const getQuotaTypesSuccess = createAction(`${moduleSlug}/GET_QUOTA_TYPES/SUCCESS`);
export const getQuotaTypesError = createAction(`${moduleSlug}/GET_QUOTA_TYPES/ERROR`);
